export enum HeadersRequestEnum {
  CONTENT_TYPE = 'Content-Type',
  CONTENT_TYPE_LOWER_CASE = 'content-type',
  X_CUSTOM_HEADERS = 'x-custom-headers',
  X_UUIDAUTH = 'x-uuidauth',
  X_AUTH_TOKEN = 'X-Auth-Token',
  XAUTHTOKEN = 'x-auth-token',
  X_CHANNEL = 'x-channel',
  X_STRCODE = 'x-strcode',
  X_RQ_UID = 'x-rquid',
}



// WEBPACK FOOTER //
// ./src/app/enums/headers-request.enum.ts